import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram, FiTwitter, FiYoutube } from 'react-icons/fi';
import { FaPinterest, FaTiktok, FaSnapchat } from 'react-icons/fa';
import CurrencySelector from './CurrencySelector';

export default function Footer() {


  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Brand & Social */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src="https://cdnbailebelle.pages.dev/header-logo.png"
                alt="Bailebelle"
                className="h-12 w-auto"
              />
            </div>

            <div className="text-gray-400 text-xs leading-relaxed space-y-4">
              <div>
                <p className="font-semibold text-white mb-1">SKYCONSULTANTS PRIVATE LIMITED</p>
                <p className="font-semibold text-white mb-2">BAILEBELLE FASHION</p>

                <p><span className="text-white font-medium">PK:</span> KARIM ABAD KHAN GHARI Dargai, Malakand KPK</p>
                <p className="mt-1"><span className="text-white font-medium">US:</span> 100 N Howard ST Spokane, Washington 99201</p>
                <p className="mt-3"><span className="text-white font-medium">Phone:</span> 0336-8886865</p>
                <p className="mt-3"><span className="text-white font-medium">Email:</span> supports@bailebelle.com</p>
                <p className="mt-2 text-[10px] text-gray-500">MCC 5697 – Tailors, Seamstresses, Custom Made Clothing</p>
              </div>
            </div>

            <div className="flex space-x-3 pt-2">
              <a
                href="https://www.pinterest.com/BailebelleFashion/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-all duration-300 transform hover:scale-110"
                aria-label="Pinterest"
              >
                <FaPinterest size={18} />
              </a>
              <a
                href="https://www.facebook.com/BailebelleFashion"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-600 transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook"
              >
                <FiFacebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/bailebellefashion/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram"
              >
                <FiInstagram size={18} />
              </a>
              <a
                href="https://x.com/bailebelle?s=11"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-black transition-all duration-300 transform hover:scale-110"
                aria-label="X (Twitter)"
              >
                <FiTwitter size={18} />
              </a>
              <a
                href="https://t.snapchat.com/wjcIrf1M"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-all duration-300 transform hover:scale-110"
                aria-label="Snapchat"
              >
                <FaSnapchat size={18} />
              </a>
              <a
                href="https://youtube.com/@BailebelleFashion"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-600 transition-all duration-300 transform hover:scale-110"
                aria-label="YouTube"
              >
                <FiYoutube size={18} />
              </a>
              <a
                href="https://tiktok.com/@bailebellefashion"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-black transition-all duration-300 transform hover:scale-110"
                aria-label="TikTok"
              >
                <FaTiktok size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Quick Links</h3>
            <ul className="space-y-1.5">
              <li>
                <Link to="/collections/dress" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  All Dresses
                </Link>
              </li>
              <li>
                <Link to="/collections/jewelry" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Jewelry Collection
                </Link>
              </li>
              <li>
                <Link to="/collections" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Categories
                </Link>
              </li>
              <li>
                <Link to="/size-guide" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Size Guide
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Customer Service</h3>
            <ul className="space-y-1.5">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Returns & Exchange
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-pink-500 transition-colors text-xs">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Business Hours & Currency */}
          <div className="space-y-3">
            <h3 className="text-base font-semibold text-white">Business Hours</h3>
            <div className="text-gray-400 text-xs leading-relaxed space-y-1">
              <p>We are available 24/7 to assist you with your orders and inquiries.</p>
              <p className="pt-2"><span className="font-semibold text-white">Business Hours:</span> 24/7</p>
            </div>
            <div className="pt-4 border-t border-gray-800">
              <div className="flex items-center gap-3">
                <span className="text-gray-400 text-xs font-medium">Currency:</span>
                <CurrencySelector />
              </div>
            </div>
          </div>
        </div>


        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-900">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p className="text-gray-400 text-xs text-center md:text-left">
              © 2025 Bailebelle Fashion. All rights reserved. | Powered by <a href="https://www.skytechnologyinc.com" target="_blank" rel="noopener" title="Visit SkyTechnology Inc">SkyTechnology Inc</a>
            </p>
            <div className="flex flex-wrap justify-center md:justify-end gap-4 md:gap-6">
              <Link to="/cookies" className="text-gray-400 hover:text-pink-500 transition-colors text-sm">
                Cookie Policy
              </Link>
              <Link to="/privacy" className="text-gray-400 hover:text-pink-500 transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-pink-500 transition-colors text-sm">
                Terms of Service
              </Link>
              <Link to="/returns" className="text-gray-400 hover:text-pink-500 transition-colors text-sm">
                Returns & Refunds
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
